const initialState = {
  data: [],
  action: null,
};

const chatNotificationData = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_CHAT_NOTIFICATION_DATA': {
      // Extract data (flatten if necessary)
      const incomingData = Array.isArray(action.payload.data)
        ? action.payload.data // Use as-is if it's already an array
        : [action.payload.data]; // Convert single object into an array

      // Filter out existing notifications based on matching RequestNo
      const filteredData = incomingData.filter(newMsg => !state.data.some(existingMsg => existingMsg.MessageID === newMsg.MessageID));
      return {
        ...state,
        data: [...filteredData, ...state.data], // Add new filtered notifications
        action: action.payload.action,
      };
    }
    case 'FILTER_NOTIFICATION_DATA': {
      // Replace existing notifications with only the filtered data
      return {
        ...state,
        data: Array.isArray(action.payload.data)
          ? action.payload.data // Directly use the filtered array
          : [action.payload.data], // If it's an object, convert to an array
        action: action.payload.action,
      };
    }
    case 'RESET_CHAT_NOTIFICATION_DATA': {
      // Reset the state to its initial state
      return initialState;
    }
    default:
      return state;
  }
};

export default chatNotificationData;
